import { DateTime } from "luxon";

import formatDateTime from "./formatDateTime";

// The trip manager's duration input starts at 2 hours, so a slot saved without one reads as 2 hours.
export const DEFAULT_TIME_SLOT_HOURS = 2;

export function tripTimeSlotHours(duration: number | null | undefined): number {
  return duration && duration > 0 ? duration : DEFAULT_TIME_SLOT_HOURS;
}

// Formats a trip's timeslot as "09:00 - 11:00" in UK time, or null when no timeslot is set.
// Only the time is shown: the date part of timeSlotStart is when the slot was saved, not the trip's day.
export function formatTripTimeSlot(
  timeSlotStart: string | null | undefined,
  duration: number | null | undefined
): string | null {
  if (!timeSlotStart) return null;

  // Parsed as UTC to match formatDateTime - adding the hours to a browser-local parse drifts the
  // end time by the UTC offset, which in BST showed a 2 hour slot as 1 hour.
  const start = DateTime.fromISO(timeSlotStart, { zone: "utc" });
  if (!start.isValid) return null;

  const end = start.plus({ hours: tripTimeSlotHours(duration) });

  return `${formatDateTime(timeSlotStart, DateTime.TIME_24_SIMPLE)} - ${formatDateTime(end.toISO(), DateTime.TIME_24_SIMPLE)}`;
}
